module.exports = __webpack_public_path__ + "img/tc-11.8bea1b01.png";